import ModelFactory from '../model-factory';
import BaseModel from '../models/base-model';
import PrimaryIndex from '../models/primary-index';

/*
@COMMON_NAME: "Información de tu interés"
@REL_ATTR: 403921
@id: 403921
AVG_RATING: 0
CREATION_DATE: 1584082175
DOC_TEMPLATE_ID: 10
HITS: 1
MODIFY_DATE: 1587054410
PRIMARY_INDEX: {@REL_ATTR: 400312, @COMMON_NAME: "Notificaciones bienvenida", @id: 400312}
SD_ACCEPTED_HITS: 0
STATUS_ID: 70
SUMMARY: "Información de tu interés"
permission_group: {id: 400099}
pgroup_id: 400099
z_refext: 1292
*/

// resolution field could start with &lt;CDATA[[(<content>)
/* const clearResolutionField = (resolution) => (resolution || '')
  .replace(/((&lt;|<)!\[CDATA\[(\n)?)|(\]\](&gt;|>))$/gm, ''); */

export default class KnowledgeItem extends BaseModel {
  constructor(data = {}) {
    super(data);

    // data keys normalization
    console.log(data);

    const parsedData = Object.fromEntries(Object.entries(data)
      .map(((entry) => [
        entry[0].toLowerCase(),
        entry[1],
      ])));

    function roundNumber(number) {
      if (number % 1 !== 0) {
        return Math.round(number * 10) / 10;
      }
      return number;
    }

    this.avgRating = typeof parsedData.avg_rating === 'number' ? roundNumber(parsedData.avg_rating) : null;
    this.creationTemplate = parsedData.creation_template || null;
    this.hits = typeof parsedData.hits === 'number' ? parsedData.hits : null;
    this.docTemplateId = parsedData.doc_template_id || null;
    this.sdAcceptedHits = typeof parsedData.sd_accepted_hits === 'number' ? parsedData.sd_accepted_hits : null;
    this.statusId = typeof parsedData.status_id === 'number' ? parsedData.status_id : null;
    this.summary = parsedData.summary || null;
    this.extReference = parsedData.z_refext || null;
    this.publishedDate = parsedData.published_date || null;
    this.modifyDate = parsedData.modify_date || null;
    this.readGroupId = typeof parsedData.read_pgroup === 'number' ? parsedData.read_pgroup : null;
    this.writeGroupId = typeof parsedData.write_pgroup === 'number' ? parsedData.write_pgroup : null;
    // this.resolution = clearResolutionField(parsedData.resolution || null);
    this.resolution = parsedData.resolution || null;
    this.zinfo_usuariofinal = parsedData.zinfo_usuariofinal || null;
    this.zVisibleInternet = typeof parsedData.zvisibilidad_internet === 'number' ? parsedData.zvisibilidad_internet : null;
    this.vote_count = data.vote_count ?? null;
    this.snippet = parsedData.snippet ?? null;

    this.primaryIndex = null;
    if (data.primary_index != null) {
      this.primary_index = new PrimaryIndex(data.primaryIndex);
    }
  }

  /**
   * we will consider an item as technical when readPermissionGroup is != '0'
   */
  isTechnical() {
    return this.readGroupId != null && this.readGroupId !== 0;
  }
}

export const modelFactory = new ModelFactory('knowledge_items', (res) => new KnowledgeItem(res));
